import { JPYCTransferProps } from './type';
import { getValueBinding } from '../../shared';

type BindingValue = {
  recipientAddress: string;
  amount: number;
  useGasless: boolean;
  'title.text': string;
  'paymentButton.text': string;
};
export const useJpycBindingValue = (props: JPYCTransferProps) => {
  const bindingValue = getValueBinding(
    props.isInCustomList ? props.initId : props.id,
    props.isInCustomList ? props?.record : props.data,
    props
  ) as any as BindingValue;
  return {
    ...bindingValue,
    useGasless: props.attributes?.useGasless,
  };
};
